(ns quuppa.qsm.dashboard.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  ::selected-files
  (fn [db _]
    (get-in db [:ui-state :selected-files] #{})))

(rf/reg-sub
  ::qsm-logs
  (fn [db [_ _]]
    (get-in db [:ui-state :qsm-logs])))
